import { pageInfo, detail, businessTypeList } from './../api';

const sapIntDatapack = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailObj: null,
    businessTypeOptions: []
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    DETAIL(state, data) {
      state.detailObj = data.obj || {};
    },
    BUSINESS_TYPE_LIST(state, data) {
      state.businessTypeOptions = data.obj || [];
    }
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detail({ commit }, id) {
      let resp = await detail(id);
      commit('DETAIL', resp);
    },
    async businessTypeList({ commit }) {
      let resp = await businessTypeList();
      commit('BUSINESS_TYPE_LIST', resp);
    }
  }
};

export default sapIntDatapack;



// WEBPACK FOOTER //
// ./src/page/log/sapIntDatapack/store/sapIntDatapack.store.js